export default __webpack_public_path__ + "static/media/impressionnism-objects.spritesheet@1x.d771f28c.png";